import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "../../_shared/withRouter";
import { APP_VERSION } from "../../actionTypes/types";
import { connect } from "react-redux";
import { logOut } from "../../_shared/commonFunction";
import { useTranslation } from "react-i18next";
import { getVisibleAdminSidebar, isTruthy } from "./sidebarVisibility";

import {
  globalAlert,
  globalLoader,
  addOrgDetailsFunc,
} from "../../actions/commonActions";
import { userBrandInfo } from "../../user/_userActions";
export const SidebarComponent = React.memo(
  ({ navbarToggle, active, roleType = null, ...props }) => {
    const { t } = useTranslation();

    const [maxHeight, setMaxHeight] = useState(0);
    const [subMenuOpen, setSubMenuOpen] = useState(false);
    const [menuVal, setMenuval] = useState(null);
    const ref = useRef();

    useEffect(() => {
      callBasicApi();
    }, []);

    useEffect(() => {
      maxHeightSidebar();
    });

    const maxHeightSidebar = () => {
      let windowHeight = window.innerHeight;
      ref && setMaxHeight(windowHeight - ref.current.offsetHeight - 50);
    };

    const hasOrgDetails = !!props?.orgDetails;
    const org = props?.orgDetails || {};
    const featureFlags = {
      lms: isTruthy(org.lmsEnabled),
    };
    const shouldShowFeatureOnlyMenu = isTruthy(org.onlyLmsEnabled);
    const visibleSidebar = hasOrgDetails
      ? getVisibleAdminSidebar(org)
      : [];
    const visibleSidebarSignature = visibleSidebar
      .map((it) => it?.value || it?.link || it?.text)
      .join("|");
    const currentPath = props?.location?.pathname || active || "";
    const lmsMenuIndex = visibleSidebar.findIndex((it) => it?.value === "lms");
    const activeMenuIndex = props?.menu
      ? visibleSidebar.findIndex((it) => it?.value === props.menu)
      : currentPath.startsWith("/admin/lms")
      ? lmsMenuIndex
      : -1;

    // Expand the section that owns the current page on load; the header click
    // then toggles it. (Previously the open state also keyed on props.menu, which
    // forced the active section's submenu permanently open — the toggle appeared
    // broken because it could never collapse.)
    useEffect(() => {
      if (activeMenuIndex >= 0) {
        setMenuval(activeMenuIndex);
        return;
      }
      if (featureFlags.lms && lmsMenuIndex >= 0 && shouldShowFeatureOnlyMenu) {
        setMenuval(lmsMenuIndex);
      }
    }, [
      activeMenuIndex,
      featureFlags.lms,
      lmsMenuIndex,
      shouldShowFeatureOnlyMenu,
      visibleSidebarSignature,
    ]);

    const callBasicApi = async () => {
      if (!props?.orgDetails) {
        try {
          globalLoader(true);

          let res = await userBrandInfo();
          if (res?.data?.status === 200) {
            addOrgDetailsFunc(res?.data?.data?.orgBrandInfo);
            globalLoader(false);
          } else {
            globalAlert(res?.data?.message);
            logOut(props?.history, `/${props?.roleType}/login`);
          }
          globalLoader(false);
        } catch (error) {
          globalAlert("error", error?.response?.data?.message);
          if (error?.response?.data?.status === 401) {
            logOut(props?.history, `${props?.roleType}/login`);
          }
          globalLoader(false);
        }
      }
    };


    return (
      <nav className="sidebar" id="sidebar">
        <div
          className="sidebar-container"
          style={{ maxHeight: maxHeight, overflowY: "auto" }}
        >
          <div className="sidebar-header pb-3">
            <div>
              <img
                alt="EC Card"
                className="sidebar-header-logo"
                src="/assets/icons/eC-Card-Logo-Square.png"
              />
            </div>
          </div>
          {visibleSidebar && visibleSidebar.length ? (
            <ul className="list-unstyled components">
              {visibleSidebar.map((item, index) => {
                return (
                  <li key={item.text}>
                    {item.subMenu ? (
                      <div
                        className={`d-flex sidebar-link cursor flex-wrap align-items-center menu-inner-wrapper ${props?.menu===item?.value || index===menuVal?'active-tab':''}`}
                        onClick={() => {
                          setSubMenuOpen(!subMenuOpen);
                          setMenuval(index === menuVal ? null : index);
                        }}
                      >
                        <div className="sidebar-icon-wrapper">
                        <i className={`sidebar-icon ${item.icon}`}></i>
                        </div>
                        <div className="sidebar-text flex-1">
                          {t(item?.text)}{" "}
                        </div>
                        <i className={`sidebar-arrow-icon fa fa-angle-down ${index===menuVal?'active':''}`}></i>

                      </div>
                    ) : (
                      <Link
                        to={`/admin/${item.link}`}
                        className={`sidebar-link ${active === `/admin/${item.link}` ? "active-tab" : ""
                          }`}
                      >
                        <i className={`sidebar-icon ${item.icon}`}></i>
                        <span className="sidebar-text">{t(item.text)}</span>
                      </Link>)}
                      {item.subMenu && index === menuVal ? (
                    <ul className="list-unstyled sidebar-submenu-list-wrapper w-100">
                      {item.subMenu.map((subMenu, index) => {
                        return (
                          <li
                            key={index}
                            className={`${
                              subMenu.value === props.subMenu ? "active" : ""
                            }`}
                          >
                            <Link to={`/admin/${subMenu.link}`}>
                              <div className={`d-flex sidebar-link flex-wrap align-items-center submenu-inner-wrapper ${props?.subMenu===subMenu?.value?'active-tab':''}`}>
                                <div className="sidebar-icon-wrapper">
                                <i className={`sidebar-icon ${subMenu.icon || item.icon}`}></i>
                                </div>
                                <div className="list-txt-wrapper sidebar-text flex-1">
                                  {t(subMenu?.text)}
                                </div>
                              </div>
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  ) : null}
                  </li>
                );
              })}
            </ul>
          ) : null}
        </div>
        <div className="footer-logo" ref={ref}>
          <img
            alt="EC Card"
            className="sidebar-header-logo"
            src={props?.orgDetails?.brandLogo}
          />
          <p className="text-white">v {APP_VERSION}</p>
        </div>
      </nav>
    );
  }
);

const mapStateProps = (state) => ({
  orgDetails: state.common.orgDetails,
});

export default connect(mapStateProps)(withRouter(SidebarComponent));
